import React from 'react';
import './menu.css';
import Logo from '../../assets/images/logo.png';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer py-5 border-top">
      <div className="container">
        <div className="row align-items-center">
          {/* Navigation Links */}
          <div className="col-md-4">
            <ul className="d-flex list-unstyled">
              <li><Link to="/">Home </Link></li>
              <li><Link to="/about">About Us </Link></li>
              <li><Link to="/whatwedo">What We Do </Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Logo */}
          <div className="col-md-4 text-center">
            <Link to="/">
              <img src={Logo} alt="Insight2Active logo" className="footer-logo" />
            </Link>
          </div>

          {/* Copyright */}
          <div className="col-md-4 text-end">
            <p>© 2024 Insight2activate. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
